import React from 'react';
import "../../styles/hero.css"; 
import hero from "../../assets/hero.png"
import { useNavigate } from "react-router-dom";


const Hero = () => {
  const navigate = useNavigate();
  return (
    <section className="hero-wrapper container">
      <div className="hero-card row  align-items-center g-0">
        
        {/* LEFT TEXT SECTION */}
        <div className="col-lg-7 col-md-12 text-content position-relative">
          {/* Background curve line pattern (optional decorative SVG can go here) */}
          
          <h1 className="hero-title">
            Your Professional<br />
            Success Starts Here
          </h1>
          
          <p className="hero-subtitle">
            Expert-led training for CA, CMA, and CS aspirants – building careers 
            with knowledge, skill, and confidence.
          </p>

          <div className="hero-buttons">
            <button className="btn-enroll"  onClick={() => navigate("/contact")} >
              Enroll Now – Secure Your Future In Finance & Corporate
            </button>
          </div>
        </div>

        {/* RIGHT IMAGE SECTION */}
        <div className="col-lg-5 col-md-12 hero-img-container position-relative d-flex justify-content-end align-items-end">
          
          {/* 1. Background Pattern (Subtle curved lines behind) */}
        {/*    <img 
            src="https://school.madhiacademy.com/wp-content/uploads/sites/2/2025/09/Asset-05-copy.png" 
            alt="Pattern" 
            className="hero-pattern"
          />
 */}
          {/* 2. The Professional Man Image */}
          <img
            src={hero}
            alt="Professional Working"
            className="hero-main-img"
          />
        </div>

      </div>
    </section>
  );
};

export default Hero;